import { requestJson } from './apiClient'
const BASE_PATH = '/api/distributors'

const apiDistributorService = {
  listDistributors(page = 0, size = 10, name = '') {
    const query = { page, size }
    if (name) {
      query.name = name
    }
    return requestJson({ method: 'GET', path: BASE_PATH, query })
  },
  getDistributorById(id) {
    return requestJson({ method: 'GET', path: `${BASE_PATH}/${id}` })
  },
  createDistributor(payload) {
    return requestJson({ method: 'POST', path: BASE_PATH, body: payload })
  },
  updateDistributor(id, payload) {
    return requestJson({ method: 'PUT', path: `${BASE_PATH}/${id}`, body: payload })
  },
  deleteDistributor(id) {
    return requestJson({ method: 'DELETE', path: `${BASE_PATH}/${id}` })
  },
}

export default apiDistributorService
